import { Chip } from "@mui/material";
export function StatusChip({ value }: { value: string }) {
  const color =
    value === "COMPLETED" || value === "ACTIVE" || value === "DELIVERED"
      ? "success"
      : value === "FAILED" || value === "DISABLED" || value === "REVOKED"
        ? "error"
        : value === "PROCESSING" || value === "RUNNING"
          ? "info"
          : "warning";
  return <Chip label={value} color={color} size="small" variant="outlined" />;
}
